
import { LoginState } from "../../models/model";
import { LoginActions } from "../interface/reducerType";

const initialState=  {
  token: '',
  userdetails: {
    Email: "",
    app_log_id: 0,
    caller_id: "",
    cli: "",
    company_id: 0,
    country_code: "",
    customer_id: 0,
    dir_user_id: 0,
    domain_id: 0,
    domain_name: "",
    dp_password: "",
    enterpriseid: 0,
    error_code: 0,
    error_msg: "",
    ext: 0,
    host_address: "",
    local_0: "",
    meeting_id: "",
    order_id: 0,
    platform: 0,
    profile_url: "",
    role_id: 0,
    sip_login_id: "",
    sip_password: "",
    site_id: 0,
    user_status: "",
    local_number: "",
    video_meet_domain:""
  },
  landingPage:true,
  historySet: "",
  dropdownNewChat:true,
  clientDomain:{
    urapi: "https://urapi.worktual.co.uk",
    audiosgw: "audiosgw.worktual.co.uk",
    videomeet: "https://meet.worktual.co.uk",
    chatsocket: "https://urchat-io.worktual.co.uk",
    audioturnv4: "turn:audioturnv4.worktual.co.uk:3478",
    audioturnv6: "turn:audioturnv6.worktual.co.uk:3478"
  }
};

export const loginReducer = (state: LoginState = initialState, action: LoginActions) => {
  switch (action.type) {
  case 'ADD_LOGIN':
    return {
      ...state, userdetails: action.payload.userdetails
    };
  case 'ADD_TOKEN':
    return {
      ...state, token: action.payload.token
    };
  case 'LANDING_PAGE':
      return {
        ...state, landingPage: action.payload.landingPage
      };
  case 'HISTORY_SET':
        return {
          ...state, historySet: action.payload.historySet
        }; 
  case 'DROPDOWN_NEWCHAT':
          return {
            ...state, dropdownNewChat: action.payload.dropdownNewChat
          };   
  case 'SSO_TOKEN_CLIENT_DOMAIN' :
    return {
      ...state,clientDomain:action.payload.clientDomain
    };
  default:
    return state;
  }
};